import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';


// types

import type { AgentResultDetails } from '../useAgentListing';

// styles

const StyledAgentDetails = styled.div`
    .name {
        font-size: 3rem;
        font-weight: 800;
    }

    .details {
        display: flex;
        justify-content: space-between;
    }

    .info {
        display: flex;
        flex-direction: column;
        gap: 20px;
        font-size: 2.0rem;

        .bold {
            font-weight: 800;
        }
    }
`;

// props


const GOOGLE_MAP_API_KEY = 'AIzaSyAGzeWeaQi0PMmEllsv_BxK13U_nmia8zg';
const DEFAULT_AVATAR = global.__ENV__.PRODUCTION ? '/hix/resources/img/simple-avatar.png' : '/assets/images/simple-avatar.png';

const AgentDetails = (props: AgentResultDetails) => {

    const {
        businessName,
        contactNumber,
        languagesSpoken,
        licenseNumber,
        profilePhotoUrl,
        productExpertise,
        yourPublicEmail,
        firstName,
        lastName,
        location: {
            address1,
            city,
            state,
            zip
        }
    } = props;

    const name = `${firstName} ${lastName}`;
    const address = `${address1} ${city}, ${state} ${zip}`;

    const showDefaultAvatar = (ev) => {
        ev.target.src = DEFAULT_AVATAR;
    };

    return (
        <StyledAgentDetails>
            <div className='name'>{name}</div>
            <hr />
            <div className='details'>
                <div><img src={profilePhotoUrl || DEFAULT_AVATAR} alt="agent's" style={{ height: '150px' }} onError={showDefaultAvatar}/></div>
                <div className='info'>
                    <div>
                        <div className='bold'>{businessName}</div>
                        <div>{address}</div>
                        <div>{contactNumber}</div>
                        <div>{yourPublicEmail}</div>
                    </div>
                    <div>
                        <div><FormattedMessage id='ga.agent.details.header.languages_spoken' /></div>
                        <div className='bold'>{languagesSpoken}</div>
                    </div>
                    <div>
                        <div><FormattedMessage id='ga.agent.details.header.product_expertise' /></div>
                        <div className='bold'>{productExpertise}</div>
                    </div>
                    <div>
                        <div><FormattedMessage id='ga.agent.details.header.license_number' /></div>
                        <div className='bold'>{licenseNumber}</div>
                    </div>
                </div>
                <div>
                    <div id="profile-map" className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                        <iframe
                            title="View Agent Location"
                            width="300"
                            height="270"
                            frameBorder="0"
                            src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAP_API_KEY}
                        &q=${address1}+${city},+${state}+${zip}`}>
                        </iframe>
                    </div>
                </div>
            </div>
        </StyledAgentDetails>
    );
};

export default AgentDetails;